interface IOutlineArrowDownIcon {
  size?: 'sm' | 'md';
  color?: string;
}

export const OutlineArrowDownIcon = (props: IOutlineArrowDownIcon) => {
  const { size = 'md', color = '#222530' } = props;
  return (
    <>
      {size === 'md' ? (
        <svg width="24" height="24" viewBox={`0 0 24 24`} fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 9L12 15L18 9" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6.81836L8 10.8184L12 6.81836" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </>
  );
};
